import dayjs from 'dayjs'

export function getCurrencyFormattedValue(amount) {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  return currencyFormatter.format(amount)
}

export function getNumberValueFormat(number) {
  return new Intl.NumberFormat('en-US').format(number)
}

export function getDateTimeFormattedValue(dateTime) {
  if (!dateTime) return ''
  return dayjs(dateTime).format('MM/DD/YYYY, hh:mm A')
}
export function getDateFormattedValue(dateTime) {
  if (!dateTime) return ''
  return dayjs(dateTime).format('MM/DD/YYYY')
}
export function getTimeFormattedValue(dateTime) {
  if (!dateTime) return ''
  return dayjs(dateTime).format('hh:mm A')
}
